import $ from 'jquery';

var CustomerSwap = (function () {
  'use strict';

  var $switchMethod = $('.js__switch-method');
  var $addressBook = $('.js__address-book');
  var $storeRow = $('.js__store-row');
  var $resellereRow = $('.js__reseller-row');

  var init = function () {
    switch ($switchMethod.val()) {
      case 'store':
        $storeRow.show();
        $addressBook.hide();
        $resellereRow.hide();

        toggleState($storeRow, true);
        toggleState($addressBook, false);
        toggleState($resellereRow, false);
        break;
      case 'courier':
        $storeRow.hide();
        $addressBook.show();
        $resellereRow.hide();

        toggleState($storeRow, false);
        toggleState($addressBook, true);
        toggleState($resellereRow, false);
        break;
      case 'reseller':
        $storeRow.hide();
        $addressBook.hide();
        $resellereRow.show();

        toggleState($storeRow, false);
        toggleState($addressBook, false);
        toggleState($resellereRow, true);
        break;
    }

    $switchMethod.on('change', function () {
      handleMethod();
    });
  };

  var handleMethod = function () {
    var methodVal = $switchMethod.val();

    switch (methodVal) {
      case 'store':
        toggleItem($storeRow, $addressBook, $resellereRow);

        toggleState($storeRow, true);
        toggleState($addressBook, false);
        toggleState($resellereRow, false);
        break;
      case 'courier':
        toggleItem($addressBook, $storeRow, $resellereRow);

        toggleState($addressBook, true);
        toggleState($storeRow, false);
        toggleState($resellereRow, false);
        break;
      case 'reseller':
        toggleItem($resellereRow, $storeRow, $addressBook);

        toggleState($addressBook, false);
        toggleState($storeRow, false);
        toggleState($resellereRow, true);
        break;
    }
  };

  var toggleItem = function (selectorOne, selectorTwo, selectorThree) {
    if (selectorOne.is(':hidden')) {
      selectorOne.transition({
        animation: 'fade left',
        hidden: 'visible',
      });
    }
    if (selectorTwo.is(':visible')) {
      selectorTwo.transition({
        animation: 'fade left',
        visible: 'hidden',
      });
    }
    if (selectorThree.is(':visible')) {
      selectorThree.transition({
        animation: 'fade left',
        hidden: 'hidden',
      });
    }
  };

  var toggleState = function (input, state) {
    input.find('input').prop('disabled', !state);
    input.find('select').prop('disabled', !state);
    input.find('.ui.dropdown.search').toggleClass('disabled', !state);
  };

  return {
    init: init,
  };
})();

export default CustomerSwap;
